import React from "react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import type { BinanceTradeSyncInfo } from "../../utils/binanceTradeSync";
import {
  BROKER_ALERT_CLASS,
  BROKER_ALERT_DESC_CLASS,
  BROKER_ALERT_TITLE_CLASS,
  BrokerAlertIcon,
} from "./brokerAlertUi";

export interface BinanceTradeSyncGuidanceProps {
  tradeSync: BinanceTradeSyncInfo;
}

const BinanceTradeSyncGuidance: React.FC<BinanceTradeSyncGuidanceProps> = ({ tradeSync }) => {
  return (
    <Alert variant="info" className={BROKER_ALERT_CLASS}>
      <BrokerAlertIcon tone="info" />
      <AlertTitle className={BROKER_ALERT_TITLE_CLASS}>
        Binance API sync: last {tradeSync.apiSyncLookbackDays} days
      </AlertTitle>
      <AlertDescription className={BROKER_ALERT_DESC_CLASS}>
        <p>{tradeSync.summary}</p>
      </AlertDescription>
    </Alert>
  );
};

export default BinanceTradeSyncGuidance;
